const MENTION_REGEX = /(\s|^)@[\w]*/g;

export { MENTION_REGEX };
